import { Button, TablePagination, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
import { IoMdArrowBack } from 'react-icons/io';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import FieldsTable from './FieldsTable';
import ApprovalStepper from './Components/ApprovalStepper';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { GetRejectData } from 'API/Ds Approval/api';
import { getConfigData } from 'API/Config/api';
import BackdropLoader from '../General/Loader';
import { GetNonFiByStatus, GetRequestByStatus, opsApprovedList } from 'API/Ds Approval/api';

function RejecttionForm(props) {
  const userType = sessionStorage.getItem('UserType');
  const [configData, setConfigData] = useState(null);
  // const userId = sessionStorage.getItem('user_id');

  // const data = [
  //     {
  //         "_id": {
  //             "$oid": "65c0c63206f7372297883f3a"
  //         },
  //         "agent_name": "Koushik",
  //         "agent_id": "001",
  //         "products": [
  //             {
  //                 "product_name": "Product A",
  //                 "ds_id": "100",
  //                 "ds_permission": "approved",
  //                 "tm_id": "string",
  //                 "tm_permission": "approved",
  //                 "sh_id": "",
  //                 "sh_permission": "pending",
  //                 "status": "active"
  //             },
  //             {
  //                 "product_name": "Product B",
  //                 "ds_id": "100",
  //                 "ds_permission": "approved",
  //                 "tm_id": "string",
  //                 "tm_permission": "pending",
  //                 "sh_id": "",
  //                 "sh_permission": "pending",
  //                 "status": "active"
  //             }
  //         ]
  //     },
  //     {
  //         "_id": {
  //             "$oid": "65c0c63206f7372297883f3b"
  //         },
  //         "agent_name": "sads",
  //         "agent_id": "002",
  //         "products": [
  //             {
  //                 "product_name": "Product A",
  //                 "ds_id": "100",
  //                 "ds_permission": "approved",
  //                 "tm_id": "string",
  //                 "tm_permission": "pending",
  //                 "sh_id": "",
  //                 "sh_permission": "pending",
  //                 "status": "active"
  //             },
  //             {
  //                 "product_name": "Product C",
  //                 "ds_id": "100",
  //                 "ds_permission": "approved",
  //                 "tm_id": "string",
  //                 "tm_permission": "approved",
  //                 "sh_id": "",
  //                 "sh_permission": "approved",
  //                 "status": "active"
  //             }
  //         ]
  //     }
  // ]

  const [data, setData] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);

  const [value, setValue] = React.useState(null);
  const [Selected, setSelected] = React.useState(null);
  const [Page, setPage] = useState(1);
  const handlePageChange = (event, page) => {
    setPage(page);
    GetRequestByStatus(page, props.status, setData, setIsLoading);
  };

  // const handleSelect=()=>{
  //     setSelected(value)
  // }

  const handleItemClick = (index) => {
    // setValue(data[index]);
    if (data) {
      if (userType === 'gm') {
        setSelected(data.all_gm_updated_ds[index]);
        setValue(data.all_gm_updated_ds[index]);
      } else {
        setSelected(data.ds_list[index]);
        setValue(data.ds_list[index]);
      }
    }
  };

  const [rows, setRows] = React.useState([]);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;

    return `${formattedTime}`;
  }

  const handleClose = () => {
    setSelected(null);
    setRows([]);
  };

  useEffect(() => {
    // GetRejectData(props.status,setData);
    if (userType !== 'gm' && userType !== 'prod_own' && userType !== 'non_fi_head') {
      opsApprovedList(Page, 10, props.status, setData, setIsLoading);
    } else if (userType === 'prod_own' || userType === 'non_fi_head') {
      GetNonFiByStatus(Page, 10, props.status, setData, setIsLoading);
    } else {
      GetRequestByStatus(Page, props.status, setData, setIsLoading);
    }
    getConfigData(setConfigData);
  }, [Page]);

  const orientation = useMediaQuery('(min-width:600px)') ? 'row' : 'column';
  const height = useMediaQuery('(min-width:600px)') ? '70vh' : '20vh';

  return (
    <>
      <BackdropLoader open={IsLoading} />
      {
        Selected ? (
          <div>
            <Stack direction="row" alignItems="center">
              <Button sx={{ width: '20px' }} onClick={handleClose}>
                <IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} />
              </Button>
              <Typography variant="subtitle1" color="grey">
                {Selected.title}
              </Typography>
            </Stack>
            <TableContainer component={Paper}>
              <FieldsTable userType={userType} configData={configData} rows={rows} selectedItem={value} />
            </TableContainer>
          </div>
        ) : (
          // data && data.length > 0 ? (
          <div style={{ width: '100%', display: 'flex', gap: '30px', flexDirection: orientation }}>
            <div style={{ height: height, overflowY: 'scroll', width: '55%', scrollbarWidth: 'none' }}>
              <Stack spacing={2} sx={{ width: '100%', height: '45rem' }}>
                {data && data ? (
                  (data.all_gm_updated_ds || data.ds_list || data.users).map((item, index) => {
                    return userType === 'gm' ||
                      userType === 'ops' ||
                      userType === 'rm' ||
                      userType === 'sh' ||
                      userType === 'cso' ||
                      userType === 'prod_own' ||
                      userType === 'non_fi_head' ? (
                      <SubCard
                        title={`Onboarding for ${item.ds_name || item.distributor_name}`}
                        key={index}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleItemClick(index)}
                      >
                        <Stack direction="column">
                          {userType === 'gm' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Created At</Typography>
                                </th>
                                <td>:</td>
                                <td>{formatDate(item.ds_added_date_time) + ' / ' + formatTime(item.ds_added_date_time)}</td>
                              </tr>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.gm_ds_status_updated_by.added_at || item.gm_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.gm_ds_status_updated_by.added_at || item.gm_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'ops' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.ops_ds_status_updated_by.update_at || item.ops_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.ops_ds_status_updated_by.update_at || item.ops_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'sh' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.sh_ds_status_updated_by.update_at || item.sh_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.sh_ds_status_updated_by.update_at || item.sh_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'rm' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.rm_ds_status_updated_by.update_at || item.rm_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.rm_ds_status_updated_by.update_at || item.rm_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'cso' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.cso_ds_status_updated_by.update_at || item.cso_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.cso_ds_status_updated_by.update_at || item.cso_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'prod_own' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.gm_ds_status_updated_by.update_at || item.gm_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.gm_ds_status_updated_by.update_at || item.gm_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : userType === 'non_fi_head' ? (
                            <table>
                              <tr>
                                <th style={{ textAlign: 'left' }}>
                                  <Typography variant="h5">Updated At</Typography>
                                </th>
                                <td>:</td>
                                <td>
                                  {formatDate(item.gm_ds_status_updated_by.update_at || item.gm_ds_status_updated_by.update_at) +
                                    ' / ' +
                                    formatTime(item.gm_ds_status_updated_by.update_at || item.gm_ds_status_updated_by.update_at)}
                                </td>
                              </tr>
                            </table>
                          ) : null}
                        </Stack>
                      </SubCard>
                    ) : null;
                  })
                ) : (
                  <Stack justifyContent="center" alignItems="center">
                    <Typography mt={1} variant="subtitle1" color="grey">
                      No distributor onboarding request available
                    </Typography>
                  </Stack>
                )}
                {data && (
                  <TablePagination
                    component="div"
                    count={data.total_count}
                    page={Page - 1}
                    rowsPerPage={data.limit}
                    onPageChange={handlePageChange}
                    rowsPerPageOptions={[10]}
                  />
                )}
              </Stack>
            </div>
            <div>
              {userType && userType.type === 'agent' ? (
                <div style={{ height: '75vh', overflowY: 'scroll', width: '100%', scrollbarWidth: 'none' }}>
                  <Stack sx={{ width: '100%', display: value ? 'flex' : 'none' }}>
                    <MainCard sx={{ width: '100%', backgroundColor: 'whitesmoke' }}>
                      <SubCard title={value ? value.product_name : ''}>
                        <ApprovalStepper data={value} />
                      </SubCard>
                    </MainCard>
                  </Stack>
                </div>
              ) : null}
            </div>
          </div>
        )
        // ) : (
        //   <Stack justifyContent="center" alignItems="center">
        //     <Typography mt={1} variant="subtitle1" color="grey">
        //       No distributor onboarding request available
        //     </Typography>
        //   </Stack>
        // )
      }
    </>
  );
}

export default RejecttionForm;
